import { useAppSelector } from "state/hooks";
import { getFullContestEntryDetailsById } from "state/slices/contests-slice";
import { Entry } from "interfaces/entry";

// Returns the set of contestant IDs the contest entry has already wagered on
// within a specific pool. Used to grey out duplicate picks in Basic contests,
// where every pick must be on a different contestant.
const useContestPickedContestantIds = (
  poolId: string | undefined,
  poolEntries: Entry[] | undefined,
  contestEntryId: string | undefined
): Set<string> => {
  const details = useAppSelector((state) =>
    getFullContestEntryDetailsById(state, contestEntryId)
  );

  const ids = new Set<string>();
  if (!poolId || !contestEntryId) return ids;
  (details?.bets || []).forEach((bet) => {
    if (bet.pool_id !== poolId) return;
    const matched = poolEntries?.find((e) => e.pool_entry_id === bet.pool_entry_id);
    if (!matched) return;
    (matched.contestant_id || "").split(";").forEach((id) => {
      if (id) ids.add(id);
    });
  });
  return ids;
};

export default useContestPickedContestantIds;
